import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useIntelligenceTopics(
  businessId: string | undefined,
  enabled = true,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.topics.getTopics.queryOptions(
      { businessId: businessId ?? "" },
      {
        enabled: Boolean(businessId) && enabled,
        staleTime: 5 * 60 * 1000,
      },
    ),
  );
}
